var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.content),function(component,index){return _c('ContentComponent',{key:index,class:_vm.questionSize(),attrs:{"component":component,"trustedContent":_vm.trustedContent}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }